import React from 'react'
import { NotificationIcon } from '../Icons'
import UserImg from '../../assets/images/user.jpg'
import { Dropdown } from 'react-bootstrap';
import { timeAgo } from '../../utils/common';
import { useNavigate } from 'react-router-dom';
const Notification = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle id="notification">
          <NotificationIcon />
        </Dropdown.Toggle >

        <Dropdown.Menu>

          <div className='notification-header'>
            <div className='notification-title'>Notifications</div>
            {/* { props.list?.length > 0 ? <div className='mark-read'>Mark as read all</div> : null } */}
            <div className='mark-read' onClick={()=>navigate('/notification-list')}>View all</div>
          </div>
          {
            props.list?.length > 0 ?
            <>
            {
              props.list?.map((item, index)=>(
                <Dropdown.Item key={index} href="javascript:void(0)">
            {/* <div className='n-user-icon'>
              <img src={UserImg} alt='user' />
            </div> */}
            <div className='n-content-wrap'>
              <div className='n-title-wrap'>
                <div className='n-title text-truncate'>{item?.title}</div>
                <div className='n-time'>{timeAgo(item?.createdAt)}</div>
              </div>
              <div className='n-message text-truncate'>{item?.message}</div>
            </div>
          </Dropdown.Item>
              ))
            }
            </>
          : <p>You have no notification</p>
          }
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default Notification